import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { colorPalette } from '@shared/config/colorsConfig';
import { SplashScreen, ForceUpdateModal } from 'app/_modules/core';
import { useAuth } from 'app/auth/hooks/useAuth';
import { TRootStackParamList } from 'app/types/navigation';
import { PdfDocument } from 'app/screens/PdfDocument';
import { DocumentViewer } from 'app/screens/DocumentViewer';
import { DocumentUploadQR } from 'app/screens/DocumentUploadQR';
import { AppointmentScreen, WherebyRoomScreen } from 'app/_modules/core/navigation/CoreScreens';
import { navigationRef } from 'app/services/NavigationService';
import React, { useRef, useState } from 'react';
import TabNavigator from './TabNavigator';
import { Telemetry } from 'app/services/telemetry/Telemetry';
import { postHog } from 'app/services/PostHogManager';
import { useVersionCheck } from '@shared/hooks/useVersionCheck';

const Stack = createNativeStackNavigator<TRootStackParamList>();
export default function RootNavigator() {
  const { isAuthenticated, isLoading } = useAuth();
  const { needsUpdate } = useVersionCheck();
  const [dismissed, setDismissed] = useState(false);
  const routeNameRef = useRef<string | undefined>(undefined);

  return (
    <>
      <ForceUpdateModal visible={needsUpdate && !dismissed} onDismiss={() => setDismissed(true)} />
      <NavigationContainer
        ref={navigationRef}
        onReady={() => {
          routeNameRef.current = navigationRef.getCurrentRoute()?.name;
        }}
      onStateChange={async () => {
        const previousRouteName = routeNameRef.current;
        const currentRouteName = navigationRef.getCurrentRoute()?.name;

        if (previousRouteName !== currentRouteName) {
          Telemetry.breadcrumb(`navigation.to.${currentRouteName}`, {
            from: previousRouteName,
            to: currentRouteName,
            type: 'navigation',
          });
          if (currentRouteName) {
            postHog.screen(currentRouteName);
          }
          routeNameRef.current = currentRouteName;
        }
      }}
    >
      <Stack.Navigator screenOptions={{ headerShown: false, contentStyle: { backgroundColor: colorPalette.white } }}>
        {!isAuthenticated || isLoading ? (
          <Stack.Screen name="Splash" component={SplashScreen} />
        ) : (
          <>
            <Stack.Screen name="Main" component={TabNavigator} />
            <Stack.Screen
              name="PdfDocumentPage"
              component={PdfDocument}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="DocumentViewerPage"
              component={DocumentViewer}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="DocumentUploadQRPage"
              component={DocumentUploadQR}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="AppointmentScreen"
              component={AppointmentScreen}
              options={{
                headerShown: false,
                presentation: 'fullScreenModal',
              }}
            />
            <Stack.Screen
              name="WherebyRoomScreen"
              component={WherebyRoomScreen}
              options={{
                headerShown: false,
                presentation: 'fullScreenModal',
                animation: 'slide_from_bottom'
              }}
            />
          </>
        )}
      </Stack.Navigator>
    </NavigationContainer>
    </>
  );
}
